import { remove, isEqual } from 'lodash';

export default {
	mutations_to_ignore: [],
	addMutation(mutation){
		this.mutations_to_ignore.push(mutation);
	},
	checkAgainstStore(mutation){
		const matching_mutations = remove(this.mutations_to_ignore, (checking_against) => isEqual(checking_against, mutation));
		return matching_mutations.length > 0;
	}
}
